module.exports = __webpack_public_path__ + "img/finalidadeimg2.d0402808.svg";